import type { User } from '@supabase/supabase-js';

export const ADMIN_EMAIL = 'samuel4121987@gmail.com';

export function isAdminUser(user: User | null | undefined): boolean {
  return user?.email?.trim().toLowerCase() === ADMIN_EMAIL;
}
